<div class="pending-booking-toast__container"
     [class.pending-booking-toast__container--busy]="actionInProgress">
  <div class="pending-booking-toast__header">
    <div class="pending-booking-toast__title"
         [title]="booking?.serviceName || ''">
      {{ serviceTitle || (booking?.serviceName ?? '') }}
    </div>
    <button type="button"
            class="pending-booking-toast__close"
            (click)="remove()"
            [attr.aria-label]="closeLabel">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <p class="pending-booking-toast__body">
    {{ bodyText }}
  </p>
  <div class="pending-booking-toast__actions">
    <button type="button"
            class="pending-booking-toast__action pending-booking-toast__action--ghost"
            [disabled]="actionInProgress"
            (click)="onLearnMore()">
      {{ learnMoreLabel }}
    </button>
    <button type="button"
            class="pending-booking-toast__action pending-booking-toast__action--danger"
            [disabled]="actionInProgress"
            (click)="onRefuse()">
      {{ refuseLabel }}
    </button>
    <button type="button"
            class="pending-booking-toast__action pending-booking-toast__action--primary"
            [disabled]="actionInProgress"
            (click)="onAccept()">
      {{ acceptLabel }}
    </button>
  </div>
</div>
